import { string } from 'prop-types';
import styled, { keyframes } from 'styled-components';
const animation1 = keyframes`
   0% {
		clip-path: polygon(0% 0%, 0% 0%, 0% 0%, 50% 50%, 0% 0%, 0% 0%, 0% 0%);
	}
	50% {
		clip-path: polygon(
			0% 0%,
			0% 100%,
			0% 100%,
			50% 50%,
			100% 0%,
			100% 0%,
			0% 0%
		);
	}
	100% {
		clip-path: polygon(
			0% 0%,
			0% 100%,
			100% 100%,
			50% 50%,
			100% 100%,
			100% 0%,
			0% 0%
		);
	}
`;
const animation2 = keyframes`
	to {
		transform: rotate(1turn);
	}
`;
const StyledSpinner = styled.div`
   border-radius: 50%;
   border: 4px solid transparent;
   box-sizing: border-box;
   position: relative;
   & div {
      animation: ${animation1} 0.7s linear alternate infinite,
         ${animation2} 0.3s linear infinite;
      border-radius: 50%;
      box-sizing: border-box;
      left: -4px;
      position: relative;
      top: -4px;
   }
`;
const Spinner = ({ color = 'var(--main)', size = 40 }) => (
   <StyledSpinner style={{ width: size, height: size }}>
      <div
         style={{ border: `4px solid ${color}`, width: size, height: size }}
      ></div>
   </StyledSpinner>
);
Spinner.propTypes = {
   color: string,
};
export default Spinner;
